import orders from "./orders";
import vaccountPayments from "./vaccount-payments";

export const nshop = {
    orders,
    vaccountPayments,
};

export default nshop;
